<template>
    <div class="py-6">
        <h1 class="title is-4"> Page introuvable :-(</h1>
        <p>La page que vous avez voulu atteindre n'existe pas (ou plus).</p>
        <p>Revenir à <router-link to="/">l'accueil</router-link> du site.</p>
        <div class="is-hidden" align="center"><img width="320" alt="not found" src="../assets/notfound.svg"></div>
    </div>
</template>
<script>
export default {
    name: 'NotFound',
    data: function() {
        return {
            maintitle: 'Page introuvable',
        }
    },
    updated() {
        this.maintitle = this.page ? this.page.title : this.maintitle;
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    line-height: 1.4em !important;
}

h3:after {
    content: "";
    display: block;
    width: 70px;
    border-bottom: 6px solid hsl(348, 100%, 61%);
    margin-bottom: 5px;
}
</style>